import { styled } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

export const StyledFilterBox = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.backgroundInput.main,
  borderRadius: '8px',
  padding: '1.875rem',
  position: 'relative',
}))

export const StyledImageContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  height: '100%',
  width: '50%',
  backgroundImage: `url('/images/patterns/join-us.png')`,
  backgroundSize: 'contain',
  backgroundPosition: 'right',
  backgroundRepeat: 'no-repeat',
  borderRadius: '8px',
}))
